import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as NotificationStore from './notification.reducer';

export const selectState = createFeatureSelector<NotificationStore.NotificationState>(
  NotificationStore.notificationFeatureKey,
);

export const getNotification = createSelector(
  selectState,
  (state: NotificationStore.NotificationState) => {
    return state && state.notification ? state.notification : null;
  },
);

export const getDeploymentNotification = createSelector(
  selectState,
  (state: NotificationStore.NotificationState) => {
    return state && state.deploymentNotification ? state.deploymentNotification : null;
  },
);

export const getPageNotification = createSelector(
  selectState,
  (state: NotificationStore.NotificationState) => {
    return state && state.pageNotification ? state.pageNotification : null;
  },
);

export const getFormErrorNotification = createSelector(
  selectState,
  (state: NotificationStore.NotificationState) => {
    return state && state.formErrorNotification ? state.formErrorNotification : null;
  },
);
